import { HStack, Text, TextProps } from 'design-system';

export interface ITableHeader extends TextProps {
  name: string;
  renderName?: JSX.Element;
  filterButtonComponent?: JSX.Element;
  sortButtonComponent?: JSX.Element;
}

export const TableHeader = ({
  name,
  renderName,
  filterButtonComponent,
  sortButtonComponent,
  ...rest
}: ITableHeader) => {
  return (
    <HStack spacing='xs'>
      {renderName ? <>{renderName}</> : <Text {...rest}>{name}</Text>}

      {/* Filter Button */}
      {filterButtonComponent && <>{filterButtonComponent}</>}

      {/* Sort Button */}
      {sortButtonComponent && <>{sortButtonComponent}</>}
    </HStack>
  );
};
